<template>
  <MembershipPage title="Before You Go">
    <template #aboveBox>
      <div class="d-flex flex-column align-items-center">
        <b>Don't leave something you love behind.</b>
        <div v-if="benefitsText.length > 0">
          <p>
            You still have:
          </p>
          <ul class="px-0">
            <li
              v-for="benefit in benefitsText"
              :key="benefit.id">
              {{ benefit.text }}
            </li>
          </ul>
        </div>
      </div>
      <div class="d-flex flex-column gap-sm">
        <p>If you cancel, you'll lose access to all of this, including the chance to buy what you've already been wearing.</p>
        <p v-if="showIsPausedVariant && !canExtendPause && ineligibleForPauseReason">
          <span v-if="ineligibleForPauseReason === 'ITEMS_OUT'">
            To extend your pause, please return or purchase any outstanding items first.
          </span>
          <span v-else-if="ineligibleForPauseReason === 'INELIGIBLE_EXTENSION_DATE'">
            You can extend your pause starting {{ formattedExtensionEligibleDate }}.
          </span>
          <span v-else>
            You can stay paused instead and keep everything.
          </span>
        </p>
        <p v-else-if="showIsPausedVariant && canExtendPause">
          You can extend your pause to keep everything.
        </p>
        <p v-else>
          You can pause instead and keep everything.
        </p>
      </div>
      <div class="d-flex flex-column gap-lgp align-items-center">
        <BaseButton
          v-if="showIsPausedVariant && canExtendPause"
          :to="{ name: 'extend-pause' }"
          text="Extend Pause"/>
        <BaseButton
          v-else-if="!showIsPausedVariant && eligibleForPause"
          :to="{ name: 'pause' }"
          text="Pause Membership"/>
        <BaseButton
          v-else-if="showIsPausedVariant && !canExtendPause"
          :disabled="true"
          text="Extend Pause"
          variant="secondary"/>
        <BaseButton
          v-else
          :to="`mailto:hi@armoire.style?subject=${encodeURIComponent('Membership Inquiry')}`"
          text="Contact Support to Pause"/>
        <BaseButton
          :to="{ name: 'cancel' }"
          variant="secondary"
          text="Cancel Membership"/>
      </div>
    </template>
  </MembershipPage>
</template>

<script setup>
import MembershipPage from '@/components/account/membership/new/MembershipPage.vue'
import BaseButton from '@shared/components/ADORN/BaseButton.vue'
import { computed, onMounted } from 'vue'
import { usePauseCancel } from '@/composables/pauseCancel.js'
import { useClientStore } from '@shared/stores/client.js'
import { storeToRefs } from 'pinia'
import useAnalytics from '@shared/composables/analytics.js'

const { membershipDetails } = storeToRefs(useClientStore())
const {
  benefitsText,
  getBilling,
  getItemPromotions,
  clientIsPaused,
  eligibleForPause,
  ineligibleForPauseReason,
  formattedExtensionEligibleDate,
  canExtendPause
} = usePauseCancel()
const { trackPageViewEvent } = useAnalytics()

onMounted(async () => {
  trackPageViewEvent('Cancel Benefits')
  await getBilling()
  await getItemPromotions()
})

const showIsPausedVariant = computed(() => {
  return clientIsPaused.value || membershipDetails.value?.pauseDate 
})

</script>

<style scoped>
li {
  list-style-position: inside;
}
</style>
